export enum CoachState {
    'Pending' = 0,
    'Approved' = 1
}